import TasksService from '@/api/TasksService.js'
import Vue from 'vue'
export const tasksModule = {
  namespaced: true,
  state: () => ({
    TasksData: [],
    TasksLoadStatus: 'request',
    paginationTasksStateParams: {
      count: 0,
      limit: 5,
      total: 0,
      page: 0
    }
  }),

  getters: {
    numPages: (state) =>
      Math.ceil(
        state.paginationTasksStateParams.total /
        state.paginationTasksStateParams.limit
      )
  },
  mutations: {
    get_all(state, data) {
      state.TasksData = [...data]
    },
    create(state, data) {
      state.TasksData.unshift(data[0])
    },
    edit_multiple(state, data) {
      let indexed = state.TasksData.findIndex((x) => x.tasks__id == data.id)
      Object.assign(state.TasksData[indexed], data.dataEdit)
    },

    delete_data(state, id) {
      let indexed = state.TasksData.findIndex((x) => x.tasks__id == id)
      state.TasksData.splice(indexed, 1)
    },

    update_pagination(state, { total, count, limit, page }) {
      state.paginationTasksStateParams = { total, count, limit, page }
    },

    load_request(state, status) {
      state.TasksLoadStatus = 'request'
    },
    load_success(state) {
      state.TasksLoadStatus = 'success'
    },
    load_error(state) {
      state.TasksLoadStatus = 'error'
    }
  },
  actions: {
    getTasksAll({ commit }, params) {
      commit('load_request')

      TasksService.getAll(params)
        .then((data) => {
          commit('update_pagination', data.data.data)
          commit('get_all', data.data.data.rows)
          commit('load_success')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
          commit('load_error')
        })
    },

    createTasksData({ commit }, createData) {
      TasksService.create(createData)
        .then((data) => {
          commit('create', data.data.data.rows)
          Vue.$toast.success('Запись добавлена')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    },

    editTasksMultiple({ commit }, { id, dataEdit }) {
      TasksService.editMultiple(id, dataEdit)
        .then((data) => {
          commit('edit_multiple', { id, dataEdit })
          Vue.$toast.success('Данные успешно обновлены')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    },

    deleteTasksData({ commit }, id) {
      // commit("load_request");
      TasksService.delete(id)
        .then((data) => {
          commit('delete_data', id)
          Vue.$toast.success('Данные успешно удалены')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    }
  }
}
